import { animate, AnimatePresence, motion, useMotionValue } from 'motion/react';
import React, { useEffect, useState } from 'react';
import { tryhardLogoPath } from '../../../svg/SVGData';
import useDebounce from '../../../../utils/hooks/useDebounce';

const root = '/thg/photo/';

const photoGallery = [
    'vinsky2002.jpg',
    'ryan_quintal.jpg',
    'mitaukano.jpg',
    'julius_drost.jpg',
    'igorovsyannykov.jpg'
]

const TryhardCarousel: React.FC = () => {
    const totalDuration = 6000;
    const [galleryCursor, setGalleryCusor] = useState(0);

    const incrementCursor = () => {
        let newCursor = (galleryCursor + 1) % photoGallery.length;
        setGalleryCusor(newCursor);
    }

    useDebounce(incrementCursor, totalDuration, [galleryCursor]);

    const pathLength = useMotionValue(0);
    useEffect(() => {
        pathLength.jump(0);
        animate(pathLength, 1, { duration: totalDuration / 1000, ease: 'linear' })
    }, [galleryCursor])

    return (
        <motion.div
            className='w-full h-[40svh] flex items-center bg-gradient-to-b from-black to-red-600 overflow-clip relative'
        >
            <AnimatePresence initial={false} mode='popLayout'>
                <motion.img
                    layout
                    key={galleryCursor}
                    className='object-cover size-full'
                    style={{ scale: 1.1 }}
                    initial={{ x: -25, opacity: 0, transition: { duration: 1 } }}
                    animate={{ x: 0, opacity: 1, transition: { duration: 1 } }}
                    exit={{ x: 25, opacity: 0, transition: { duration: 1 } }}
                    src={`${root}${photoGallery[galleryCursor]}`}
                />
            </AnimatePresence>

            {/* Absolutely positioned elements */}
            <h2
                className='italic text-sun text-gray-200 text-xl sm:text-4xl pb-4 inset-x-1/2 -translate-x-1/2 min-w-max bottom-0 absolute z-30'
                style={{ filter: 'drop-shadow(0px 4px 8px rgba(0, 0, 0, 1))' }}
            ><span className='hidden sm:inline-block'>&mdash;</span> Quality Game Gear <span className='hidden sm:inline-block'>&mdash;</span></h2>
            {/* Filter */}
            <div className='size-full bg-gradient-to-b from-black to-red-600 opacity-60 top-0 left-0 absolute' />

            {/* Transition Timer */}
            <AnimatePresence mode='popLayout'>
                <motion.div key={galleryCursor} className='bottom-4 right-4 absolute z-50'>
                    <svg
                        className='size-5 mt-px opacity-70 inset-1/2 z-10 absolute'
                        style={{ transform: 'translate(-50%, -50%)' }}
                        fill={'white'}
                        viewBox="0 0 100 138" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d={tryhardLogoPath} />
                    </svg>
                    <motion.svg
                        className='size-12 -rotate-90'
                        style={{ fill: 'none' }}
                        viewBox='0 0 54 54'
                    >
                        <circle
                            cx='27' cy='27' r='22'
                            pathLength={1}
                            style={{
                                fill: 'black', opacity: .1,
                                stroke: 'rgb(0 0 0 / .5)',
                                strokeWidth: '15%',
                            }} />
                        <motion.circle
                            cx='27' cy='27' r='22'
                            style={{
                                pathLength,
                                stroke: 'rgb(255 255 255 / 1)',
                                strokeWidth: '15%'
                            }} />
                    </motion.svg>
                </motion.div>
            </AnimatePresence>
        </motion.div>

    )
}

export default TryhardCarousel;